
import { Hero } from "@/components/Hero";
import { Benefits } from "@/components/Benefits";
import { Pricing } from "@/components/Pricing";
import { FAQ } from "@/components/FAQ";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { DebugPanel } from "@/components/debug/DebugPanel";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <Hero />
        <Benefits />
        <Pricing />
        <FAQ />
      </main>
      <Footer />
      <DebugPanel />
    </div>
  );
};

export default Index;
